const encodeURI = [function () {
  return (input) => {
    return input ? window.encodeURIComponent(input) : '';
  };
}]

export { encodeURI }
